<template>
  <div class="fts-tabs">
    <div class="tabs-header">
      <div 
        class="tabs-selection" 
        v-for="(tab, ind) in tabs" 
        :key="`${uid}-${ind}`" 
        :class="{active: selectedIndex == ind}"
        @click="selectTab(ind)"
      >
        <slot name="title" :title="tab.title">{{tab.title}}</slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: Number
  },
  data: () => ({
    uid: null,
    selectedIndex: 0,
    tabs: [],
  }),
  methods: {
    selectTab (i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i);
      });
      this.$emit("update:currentTab", this.selectedIndex);
      this.$emit("selected", this.selectedIndex);
    }
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.uid = this._uid;
    this.selectTab(this.currentTab || 0);
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;
@use "./src/assets/scss/colors" as *;

.fts-tabs {
  .tabs-header {
    max-width: 100%;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: .75rem;
    background-color: var(--fts-gray-100);
    .tabs-selection {
      @include user-select-none;
      padding: .575rem 1rem;
      border-bottom: 2px solid transparent;
      font-size: .75rem;
      font-weight: 500;
      cursor: pointer;
      &:not(.active) {
        &:hover {
          @include theme() {
            background: rgba($color: theme-get('fts-gray-300'), $alpha: 0.5);
          }
        }
      }
      &.active {
        @include theme() {
          background: rgba($color: theme-get('fts-primary'), $alpha: 0.095);
        }
        border-bottom-color: var(--fts-primary);
        color: var(--fts-primary);
      }
    }
  }
}
</style>